/**
 *
 * @param {string | number} px
 * @param {number} base
 * @returns
 */
export const pxToRem = (px, base = 16) => {
  if (typeof px === 'string') return px
  return `${px / base}rem`
}
/**
 *
 * @param {string} string
 * @returns
 */
export const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1)
